import { RESET_LOADING, LOADING_START, LOADING_STOP } from './actions';

export function loading(state = { pendingApiArray: [] }, action) {
  switch (action.type) {
    case RESET_LOADING: {
      return Object.assign({}, state, { pendingApiArray: [] });
    }

    case LOADING_START: {
      const { pendingApiArray } = state;
      let newPendingApiArray = pendingApiArray;
      const { incomingApi } = action;
      const isApiAlreadyPending = pendingApiArray.indexOf(incomingApi);
      if (isApiAlreadyPending === -1) {
        newPendingApiArray = newPendingApiArray.concat(incomingApi);
        return Object.assign({}, state, { pendingApiArray: newPendingApiArray });
      }
      return state;
    }

    case LOADING_STOP: {
      let newPendingApiArray = [];
      const { pendingApiArray } = state;
      const { incomingApi } = action;
      const isApiAlreadyPending = pendingApiArray.indexOf(incomingApi);
      if (isApiAlreadyPending > -1) {
        newPendingApiArray = pendingApiArray.filter(item => item !== incomingApi);
        return Object.assign({}, state, { pendingApiArray: newPendingApiArray });
      }
      return state;
    }

    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/shells/LoadingComponent/reducers.js